import React from 'react';
import { history } from 'umi';

import styles from './styles.scss';


export default (props) => {

  const { dataList } = props;

  return (
      <div>
        <div className={styles.categoryHeader} style={{backgroundColor: '#F5A810'}}>
          <div className={styles.line}/>会员专享<div className={styles.line}/>

          <a onClick={() => {
            history.push({pathname:'/home/memberList'})
          }}>更多></a>
        </div>

        <div className={styles.hot_box}>
         {dataList.map((item,i) =>(<HotItem key={i+''} item={item}/>))}
        </div>
      </div>

  )

}



const HotItem = (props) => {
  const { item } = props;

  return(
    <div className={styles.hot_item} onClick={() =>{
      history.push('/home/courseDetail?courseId=' + item.id + '&title=' + item.name);

    }}>
      <div className={styles.hot_imgBox}>
        <img className={styles.hot_img} alt='' src={item.image}/>
        <img className={styles.hot_play} src={require('@/assets/ic_play.png')}/>
      </div>

      <div className={styles.hot_title}>
        <label className={styles.hot_title_name}>{item.name}</label>
        <label className={styles.hot_title_num}>{item.totalHours}集</label>
      </div>

    </div>
  )
}

